/**
 *
 * AdministratorBC View constants
 *
 */

export const ADMINISTRATOR_BC_ANNOUNCEMENT_DX_GRID = 'AdministratorBCAnnouncementDxGrid';
export const ADMINISTRATOR_BC_ANNOUNCEMENT_FORM = 'AdministratorBCAnnouncementForm';
export const ADMINISTRATOR_BC_ANNOUNCEMENT_FORM_DIALOG = 'AdministratorBCAnnouncementFormDialog';

export const EXECUTE_EDIT_ACTION = 'claris-vnext/AnnouncementPage/AdministratorBCView/EXECUTE_EDIT_ACTION';
export const EXECUTE_VIEW_ACTION = 'claris-vnext/AnnouncementPage/AdministratorBCView/EXECUTE_VIEW_ACTION';
export const HANDLE_PARAMS_ACTION = 'claris-vnext/AnnouncementPage/AdministratorBCView/HANDLE_PARAMS_ACTION';

